// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabSwiperC_comp__JRGQm"};